<script>
import PersonnelFormItem from '@components/personnel/personnel-form-item.vue'
import { accessibleTerminateUser, deactivateUser, requestDeactivationForUser } from '@src/api/personnelManagement'
import { parseErrorMessage } from '@utils/string-helpers'
import FormItem from '@components/form-item.vue'

export default {
  components: {
    FormItem,
    PersonnelFormItem,
  },
  props: {
    user: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      mottoForwardEmail: null,
      assignFilesTo: null,
      modalButtonLoading: false,
      reasonsForTermination: [
        'Employee is changing industries',
        'Employee is moving to a competitor',
        'Downsizing',
        'Failure to meet performance standards',
        'Violation of company policies',
        'Other',
      ],
      terminationReasonLoPhaseTwo: null,
      terminationReasonLoPhaseTwoOther: null,
    }
  },
  computed: {
    shouldAskForDeactivationReview() {
      return !!this.user?.shouldReviewDeactivation
    },
  },
  methods: {
    clearAllData() {
      this.mottoForwardEmail = null
      this.assignFilesTo = null
      this.terminationReasonLoPhaseTwo = null
      this.terminationReasonLoPhaseTwoOther = null
    },
    async openDeactivateUserModal() {
      this.$bvModal.show('modalDeactivateUser')
    },
    handleDeactivateModalOk(bvOkEvent) {
      this.clearAllData()
      this.$bvModal.hide('modalDeactivateUser')
      if (this.user.isThirdParty) {
        this.$bvModal.show('modalAskForConfirmationThirdParty')
        return
      }
      if (this.user.isAccessOnly) {
        this.inactivateUser(bvOkEvent)
        return
      }
      this.$bvModal.show('modalAskForUserAccess')
    },

    askForUserAccessModalOk() {
      this.$bvModal.hide('modalAskForUserAccess')
      this.$bvModal.show('modalAccessibleTerminateUser')
    },

    askForActiveLoanFilesOk() {
      this.$bvModal.hide('modalAskForActiveLoanFiles')
      this.$bvModal.show('modalAskForActiveLoansFilesAssignment')
    },

    async askForReasonForTermination(bvOkEvent) {
      try {
        if (!this.user?.isLoPhaseTwo) {
          await this.askForDeactivationReview(bvOkEvent)
          return
        }
        this.$bvModal.hide('modalAskForActiveLoanFiles')
        this.$bvModal.hide('modalAskForActiveLoansFilesAssignment')
        this.$bvModal.show('modalAskForReasonForTermination')
      } catch (err) {
        this.$bvToast.toast(parseErrorMessage(err), {
          toaster: 'b-toaster-bottom-center',
          toastClass: 'toast-error',
        })
      } finally {
        this.modalButtonLoading = false
      }
    },

    async askForDeactivationReview(bvOkEvent) {
      try {
        this.modalButtonLoading = true
        bvOkEvent.preventDefault()
        const { data: user } = await requestDeactivationForUser({
          userId: this.user.id,
          mottoForwardEmail: this.mottoForwardEmail,
          loanToTransfer: this.assignFilesTo,
          terminationReasonLoPhaseTwo: this.terminationReasonLoPhaseTwo,
          terminationReasonLoPhaseTwoOther: this.terminationReasonLoPhaseTwoOther,
        })
        this.$root.$bvToast.toast('Deactivation request has been submitted and is currently under review', {
          toaster: 'b-toaster-bottom-center',
          toastClass: 'toast-success',
        })
        this.$emit('update-user', user)
        this.$bvModal.hide('modalAskForActiveLoansFilesAssignment')
        this.$bvModal.hide('modalAskForActiveLoanFiles')
        this.$bvModal.hide('modalAskForReasonForTermination')
      } catch (err) {
        this.$bvToast.toast(parseErrorMessage(err), {
          toaster: 'b-toaster-bottom-center',
          toastClass: 'toast-error',
        })
      } finally {
        this.modalButtonLoading = false
      }
    },

    async inactivateUser(bvOkEvent) {
      try {
        if (this.shouldAskForDeactivationReview) {
          this.$bvModal.hide('modalAskForUserAccess')
          this.$bvModal.show('modalAskForActiveLoanFiles')
          return
        }
        this.modalButtonLoading = true
        bvOkEvent.preventDefault()
        const { data: user } = await deactivateUser({ userId: this.user.id })

        this.$root.$bvToast.toast(
          'This user has been successfully deactivated.  To reactivate this account, please email help@mottomortgage.com or call 866-MOTTO60',
          {
            toaster: 'b-toaster-bottom-center',
            toastClass: 'toast-success',
          }
        )
        this.$emit('update-user', user)
        this.$bvModal.hide('modalAskForUserAccess')
        this.$bvModal.hide('modalAskForConfirmationThirdParty')
      } catch (err) {
        this.$bvToast.toast(parseErrorMessage(err), {
          toaster: 'b-toaster-bottom-center',
          toastClass: 'toast-error',
        })
      } finally {
        this.modalButtonLoading = false
      }
    },

    async accessibleTerminateUser(bvOkEvent) {
      try {
        if (this.shouldAskForDeactivationReview) {
          this.$bvModal.hide('modalAskForUserAccess')
          this.$bvModal.show('modalAskForActiveLoanFiles')
          return
        }
        this.modalButtonLoading = true
        bvOkEvent.preventDefault()
        const { data: user } = await accessibleTerminateUser({
          user: this.user,
          userId: this.user.id,
          newSecondaryEmail: this.mottoForwardEmail,
        })
        this.$root.$bvToast.toast(
          'You will receive a password reset email in your selected Motto forwarding email address inbox.  You have 30 days of access to this account.',
          {
            toaster: 'b-toaster-bottom-center',
            toastClass: 'toast-success',
          }
        )

        this.mottoForwardEmail = null
        this.$emit('update-user', user)
        this.$bvModal.hide('modalAccessibleTerminateUser')
      } catch (err) {
        this.$bvToast.toast(parseErrorMessage(err), {
          toaster: 'b-toaster-bottom-center',
          toastClass: 'toast-error',
        })
      } finally {
        this.modalButtonLoading = false
      }
    },
  },
}
</script>

<template>
  <div>
    <b-modal
      id="modalDeactivateUser"
      modal-class="confirmation-modal"
      title="Deactivate User"
      ok-variant="danger"
      ok-title="Yes"
      :centered="true"
      :cancel-disabled="modalButtonLoading"
      :ok-disabled="modalButtonLoading"
      @ok="handleDeactivateModalOk">
      Are you sure you want to deactivate this user?
    </b-modal>
    <b-modal
      id="modalAskForUserAccess"
      modal-class="confirmation-modal"
      title="Deactivate User"
      :cancel-title="shouldAskForDeactivationReview ? 'No' : 'No, just deactivate'"
      ok-variant="danger"
      ok-title="Yes"
      :centered="true"
      :cancel-disabled="modalButtonLoading"
      :ok-disabled="modalButtonLoading"
      @cancel="inactivateUser"
      @ok="askForUserAccessModalOk">
      Do you require access to this User’s Motto email account?
    </b-modal>
    <b-modal
      id="modalAskForConfirmationThirdParty"
      modal-class="confirmation-modal"
      title="Deactivate User"
      cancel-title="Cancel"
      ok-variant="danger"
      ok-title="Deactivate"
      :centered="true"
      :cancel-disabled="modalButtonLoading"
      :ok-disabled="modalButtonLoading"
      @ok="inactivateUser">
      This deactivates the user’s MottoCenter and MottoLearn accounts only. To deactivate this user in wemlo LBS, login
      to your wemlo LBS brokerage account, click on My account, select Roles, scroll down to the processors section, and
      toggle the status indicator to Inactive.
    </b-modal>
    <ValidationObserver v-slot="{ failed: modalValidationFailed }">
      <b-modal
        id="modalAccessibleTerminateUser"
        modal-class="confirmation-modal"
        title="Deactivate User"
        ok-variant="danger"
        ok-title="Submit"
        :cancel-disabled="modalButtonLoading"
        :ok-disabled="modalButtonLoading || modalValidationFailed || !mottoForwardEmail"
        :centered="true"
        @cancel="openDeactivateUserModal"
        @ok="accessibleTerminateUser">
        Please enter the Motto email where you would like to receive the password reset email for this account.
        <PersonnelFormItem
          class="mt-4"
          label="Motto forwarding email"
          :value.sync="mottoForwardEmail"
          edit-mode
          rules="required|email|mottoEmailDomain"
          placeholder="Email" />
      </b-modal>
    </ValidationObserver>
    <b-modal
      id="modalAskForActiveLoanFiles"
      modal-class="confirmation-modal"
      title="Deactivate User"
      cancel-title="No, just deactivate"
      ok-variant="danger"
      ok-title="Yes"
      :centered="true"
      :cancel-disabled="modalButtonLoading"
      :ok-disabled="modalButtonLoading"
      @cancel="askForReasonForTermination"
      @ok="askForActiveLoanFilesOk">
      Is this user assigned to any active loan files?
    </b-modal>
    <ValidationObserver v-slot="{ failed: modalValidationFailed }">
      <b-modal
        id="modalAskForActiveLoansFilesAssignment"
        modal-class="confirmation-modal"
        title="Deactivate User"
        cancel-title="Cancel"
        ok-variant="danger"
        ok-title="Submit"
        :centered="true"
        :cancel-disabled="modalButtonLoading"
        :ok-disabled="modalButtonLoading || modalValidationFailed || !assignFilesTo"
        @ok="askForReasonForTermination">
        <PersonnelFormItem
          class="mt-4"
          label="Who should those files be assigned to?"
          :value.sync="assignFilesTo"
          edit-mode
          rules="required" />
      </b-modal>
    </ValidationObserver>
    <ValidationObserver>
      <b-modal
        id="modalAskForReasonForTermination"
        modal-class="confirmation-modal"
        title="Reason for Termination"
        ok-variant="danger"
        ok-title="Deactivate"
        cancel-variant="space-only"
        :centered="true"
        :ok-disabled="
          modalButtonLoading ||
          !terminationReasonLoPhaseTwo ||
          (terminationReasonLoPhaseTwo === 'Other' && !terminationReasonLoPhaseTwoOther)
        "
        @ok="askForDeactivationReview">
        Your honest feedback is invaluable and will be used to make meaningful improvements in our organization. Please
        know that your responses will be kept confidential.
        <FormItem
          label="Reason For Termination"
          edit-mode
          class="mt-4 flex-shrink-0"
          :value.sync="terminationReasonLoPhaseTwo"
          :edit-select-values="reasonsForTermination"
          :options="{ hideLabel: true }"
          rules="required"
          placeholder="Select..." />
        <FormItem
          v-show="terminationReasonLoPhaseTwo === 'Other'"
          class="mt-4"
          textarea
          label="Other"
          rules="max:250|required"
          :character-limit-options="{ showOnlyError: true }"
          :value.sync="terminationReasonLoPhaseTwoOther"
          :options="{ hideLabel: true }"
          edit-mode />
      </b-modal>
    </ValidationObserver>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
